import { resolvePatientMockBundleKey } from '../patients/utils';
import { IV_BY_PATIENT, IV_DEFAULT } from './mockData';
import type { IvCommChannel, IvPatientInvisalignBundle } from './types';

export function getPatientInvisalignBundle(patientId: string): IvPatientInvisalignBundle {
  const key = resolvePatientMockBundleKey(patientId);
  return IV_BY_PATIENT[key] ?? IV_DEFAULT;
}

export function ivCommChannelLabel(channel: IvCommChannel): string {
  if (channel === 'email') return 'Email';
  if (channel === 'sms') return 'SMS';
  return 'Call';
}

export function ivCommChannelTone(channel: IvCommChannel): string {
  if (channel === 'email') return 'var(--success)';
  if (channel === 'sms') return 'var(--info)';
  return 'var(--ai-4)';
}

export function ivFormatCoverage(amount: number): string {
  return `$${amount.toLocaleString()}`;
}
